import type { NavbarNextPageButtonFragment } from "../client/generated";
import { useTranslation } from "react-i18next";
import { mdiChevronRight } from "@mdi/js";
import { NavbarButton } from "../shell/NavbarButton";
import { NavbarButtonIcon } from "../shell/NavbarButtonIcon";
import { routingPaths } from "../navigation/constants";
import { useNavigateTransition } from "../navigation/useNavigateTransition";

type Props = {
  fragment?: NavbarNextPageButtonFragment;
  disabled?: boolean;
};

export function NavbarNextPageButton({ fragment }: Props) {
  const { t } = useTranslation();
  const [isPending, navigate] = useNavigateTransition();

  const onClick = () => {
    if (fragment && fragment.nextPage) {
      navigate(
        routingPaths.documentPage(fragment.document.id, fragment.nextPage.id),
      );
    }
  };

  return (
    <NavbarButton
      tooltip={t("NavbarNextPageButton.tooltip")}
      loading={isPending}
    >
      <NavbarButtonIcon
        path={mdiChevronRight}
        disabled={!fragment?.nextPage}
        onClick={onClick}
      />
    </NavbarButton>
  );
}
